import Link from 'next/link';
import { blogPressData } from '@/data/blogPress.data';
import styles from './blogPress.module.scss';

const BlogPress = () => {
  return (
    <div className={styles.blogComponentContent}>
      {blogPressData.map((item) => (
        <Link
          key={item.id}
          href={item.href}
          target={item.external ? '_blank' : undefined}
          className={styles.blogComponentPressItem}
        >
          <h2 className={styles.blogComponentPressItemTitle}>{item.title}</h2>
        </Link>
      ))}
    </div>
  );
};

export default BlogPress;
